export default function DashboardCard({title, children, className}) {

    let topClassName = 'comp__roundedBox col-span-full xl:col-span-6 bg-white dark:bg-slate-800 '+
        'shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 ' + className

    return (
        <div
            className={topClassName}>
            <header className="px-5 py-4 border-b border-slate-100 dark:border-slate-700">
                <h2
                    className="font-semibold text-gray-800 dark:text-slate-100"
                >
                    {title}
                </h2>
            </header>
            <div className="p-4">
                {children}
            </div>
        </div>
    );
}